import React from 'react';
import PropTypes from 'prop-types';

export default function OrgContactInfo(props) {
  const {
    handlePropUpdate,
    handleSettingsUpdate,
    handlePhoneNumberUpdate,
    org,
  } = props;
  return (
    <div className="row">
      <div className="col-12 col-md-6 order-md-1">
        <div className="form-group">
          <label htmlFor="name">Organization Name</label>
          <input
            name="name"
            type="text"
            className="form-control"
            value={org.name || ''}
            onChange={handlePropUpdate}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 order-md-3">
        <div className="form-group">
          <label htmlFor="street1">Street Address</label>
          <input
            name="street1"
            type="text"
            className="form-control"
            value={org.street1 || ''}
            onChange={handlePropUpdate}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 order-md-5">
        <div className="form-group">
          <label htmlFor="street2">Suite/PO Box</label>
          <input
            name="street2"
            type="text"
            className="form-control"
            value={org.street2 || ''}
            onChange={handlePropUpdate}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 order-md-2">
        <div className="form-group">
          <label htmlFor="city">City</label>
          <input
            name="city"
            type="text"
            className="form-control"
            value={org.city || ''}
            onChange={handlePropUpdate}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 order-md-4">
        <div className="form-group">
          <label htmlFor="state">State/Province</label>
          <input
            name="state"
            type="text"
            className="form-control"
            value={org.state || ''}
            onChange={handlePropUpdate}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 order-md-6">
        <div className="form-group">
          <label htmlFor="zip">Zip Code/Postal Code</label>
          <input
            name="zip"
            type="text"
            className="form-control"
            value={org.zip || ''}
            onChange={handlePropUpdate}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 order-md-7">
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            name="email"
            type="email"
            className="form-control"
            value={org.settings?.email || ''}
            onChange={handleSettingsUpdate}
          />
        </div>
      </div>
      <div className="col-12 col-md-6 order-md-8">
        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            name="phoneNumber"
            type="text"
            className="form-control"
            value={org.phoneNumber || ''}
            onChange={handlePhoneNumberUpdate}
          />
        </div>
      </div>
      <style jsx>{`
        .form-control:focus {
          box-shadow: none;
        }
      `}</style>
    </div>
  );
}

OrgContactInfo.propTypes = {
  handlePropUpdate: PropTypes.func,
  handleSettingsUpdate: PropTypes.func,
  handlePhoneNumberUpdate: PropTypes.func,
  org: PropTypes.object,
};

OrgContactInfo.defaultProps = {
  org: { settings: {} },
};
